import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabaseClient } from "@/lib/supabase";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const { error } = await supabaseClient.auth.getUser();

    if (error) {
      throw redirect({
        to: "/login",
      });
    }
  },
});
